// Mock data for Geekynd India

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Industries', path: '/industries' },
  { label: 'AI System', path: '/ai-system' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const OPERATIONAL_SERVICES = [
  {
    icon: 'UserSquare2',
    title: 'Virtual Assistants',
    desc: 'Seamless support for your daily operations',
  },
  {
    icon: 'Headphones',
    title: 'Customer Support Teams',
    desc: 'Exceptional service, delivered at scale',
  },
  {
    icon: 'BrainCircuit',
    title: 'AI Automation',
    desc: 'Smart systems that work while you sleep',
  },
];

export const PROCESS_SERVICES = [
  {
    icon: 'Settings',
    title: 'Backend Operations',
    desc: 'Subtle systems powering smooth execution',
  },
  {
    icon: 'TrendingUp',
    title: 'Sales & Outreach',
    desc: 'Consistent pipelines. Predictable growth',
  },
  {
    icon: 'Briefcase',
    title: 'Executive Assistance',
    desc: 'Precision support for high-level decisions',
  },
  {
    icon: 'Code2',
    title: 'Technical Teams',
    desc: 'Built to scale. Engineered to perform',
  },
  {
    icon: 'Megaphone',
    title: 'Marketing Teams',
    desc: 'Data-driven strategies that convert',
  },
  {
    icon: 'PhoneCall',
    title: 'Virtual Receptionists',
    desc: 'First impressions handled flawlessly',
  },
];

export const INDUSTRIES = [
  {
    title: 'Startup',
    tagline: 'Built to scale fast',
    image: 'https://images.unsplash.com/photo-1518365050014-70fe7232897f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'Agencies',
    tagline: 'Deliver faster. Scale smarter',
    image: 'https://images.unsplash.com/photo-1660165458059-57cfb6cc87e5?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'E-Commerce',
    tagline: 'Every order, flawlessly managed',
    image: 'https://images.unsplash.com/photo-1600176842418-f7c1d1035ef1?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'SaaS',
    tagline: 'Reliable systems for growth',
    image: 'https://images.unsplash.com/photo-1653549893012-b8b4fbe97630?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'Real Estate',
    tagline: 'Leads handled, deals closed',
    image: 'https://images.unsplash.com/photo-1600132806370-bf17e65e942f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'Healthcare',
    tagline: 'Patients first, ops simplified',
    image: 'https://images.unsplash.com/photo-1655720828018-edd2daec9349?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'Finance & Fintech',
    tagline: 'Compliance + growth, hand in hand',
    image: 'https://images.unsplash.com/photo-1639768939489-025b90ba9f23?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
  {
    title: 'Consulting',
    tagline: 'Insights into action, globally',
    image: 'https://images.unsplash.com/photo-1597733336794-12d05021d510?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  },
];

export const PROCESS_STEPS = [
  { step: 'Step 1', title: 'Business Audit' },
  { step: 'Step 2', title: 'Operational Strategy' },
  { step: 'Step 3', title: 'Team Assembly' },
  { step: 'Step 4', title: 'SOP + Workflow Setup' },
  { step: 'Step 5', title: 'AI Integration' },
  { step: 'Step 6', title: 'Optimization & Scaling' },
];

export const TESTIMONIALS = [
  {
    quote: 'Geekynd India set up our entire backend operations in 3 weeks. We went from chaos to compounding growth. The AI integration is genuinely a game changer.',
    name: 'Aarav Mehta',
    role: 'Founder, D2C Brand',
    city: 'Bengaluru',
  },
  {
    quote: 'We were drowning in client emails and CRM updates. Their team plugged in seamlessly and our agency is now closing 40% more retainers.',
    name: 'Priya Sharma',
    role: 'CEO, Marketing Agency',
    city: 'Mumbai',
  },
  {
    quote: 'From customer support to invoicing — everything runs on autopilot now. The team feels like an extension of ours, not a vendor.',
    name: 'Rohan Verma',
    role: 'Co-Founder, SaaS Startup',
    city: 'Gurugram',
  },
];

export const PRICING_PLANS = [
  {
    name: 'Starter',
    hours: '3 hours/day',
    sub: '(~60 hrs/month)',
    price: '\u20B9 24,999',
    period: '/ month',
    desc: 'Ideal for solo founders and lean teams getting started.',
    features: [
      'Dedicated virtual assistant',
      'Email & calendar management',
      'Basic AI workflows',
      'WhatsApp + Email support',
    ],
    cta: 'Get Started',
    highlight: false,
  },
  {
    name: 'Professional',
    hours: '6 hours/day',
    sub: '(~120 hrs/month)',
    price: '\u20B9 44,999',
    period: '/ month',
    desc: 'For growing businesses needing serious operational firepower.',
    features: [
      'Multi-skilled VA team',
      'CRM + Sales pipeline ops',
      'AI agent integration',
      'Dedicated account manager',
      'Priority support',
    ],
    cta: 'Most Popular',
    highlight: true,
  },
  {
    name: 'Elite',
    hours: '8 hours/day',
    sub: '(~160 hrs/month)',
    price: '\u20B9 64,999',
    period: '/ month',
    desc: 'A full operational engine for scale-ups and established teams.',
    features: [
      'Full-time dedicated team',
      'Custom AI automation builds',
      'SOPs + workflow architecture',
      '24/7 coverage available',
      'Strategy reviews monthly',
    ],
    cta: 'Talk to Sales',
    highlight: false,
  },
];

export const STATS = [
  { value: '150+', label: 'Indian Businesses Served' },
  { value: '40+', label: 'AI Workflows Deployed' },
  { value: '24/7', label: 'Operational Coverage' },
  { value: '\u20B91Cr+', label: 'Operating Costs Saved' },
];

export const COMPANY = {
  name: 'Geekynd India',
  legal: 'Geekynd Services India Pvt. Ltd.',
  email: 'hello@geekyndindia.com',
  whatsapp: '+91 98765 43210',
  phone: '+91 98765 43210',
  locations: ['Bengaluru', 'Delhi NCR', 'Guwahati'],
  copyright: '\u00A9 2026 Geekynd Services India Pvt. Ltd.',
};
